import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../../../services/api/axios";

const fetchCurrencies = async (search) => {
  const response = await api.get("/v1/currency", {
    params: search ? { search } : undefined,
  });
  return response.data;
};

export const useCurrencies = (search) => {
  return useQuery({
    queryKey: ["currencies", search],
    queryFn: () => fetchCurrencies(search),
    refetchOnWindowFocus: false,
  });
};

const updateCurrency = async ({ uuid, payload }) => {
  const { data } = await api.patch(`/v1/currency/${uuid}`, payload);
  return data;
};

export const useUpdateCurrency = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateCurrency,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["currencies"] });
    },
  });
};
